import store from "store/dist/store.legacy";
import LZString from "store/plugins/lib/lz-string";

const compressionPlugin = () => ({
  get(superFn, key) {
    const val = superFn(key);
    if (!val) return val;

    try {
      const decompressed = LZString.decompress(val);
      // fallback to existing values that are not compressed
      return decompressed == null ? val : this._deserialize(decompressed);
    } catch (e) {
      return val;
    }
  },

  set(superFn, key, val) {
    try {
      const compressed = LZString.compress(this._serialize(val));
      superFn(key, compressed);
      return val;
    } catch (e) {
      superFn(key, this._serialize(val));
      return val;
    }
  },
});

store.addPlugin(compressionPlugin);

export default store;
